import { connect } from 'react-redux'
import { get } from 'lodash'

import TownsRankingComponent from './component'

import { getRankingByClientId } from '../../../../../../store/strategistV2/clientdetail/action'

const TownsRankingContainer = connect(
  // Map state to props
  (state) => ({
    towns: get(state, 'strategistV2.clientDetail.towns', []),
    isTownRated: get(state, 'strategistV2.clientDetail.isTownRated', false),
    getTownAndAgentRateData: get(state, 'client.getTownAndAgentRateData', {}),
  }),
  // Map actions to dispatch and props
  {
    getRankingByClientId,
  }
)(TownsRankingComponent)

export default TownsRankingContainer
